// GENERATED FILE - DO NOT EDIT BY HAND.
// Source of truth: state/deal-folders.json in Favosite/video-worker (the
// publish record written by publish.js) + the live deal API for titles.
// Regenerate: node generate-library-mappings.js in Favosite/video-worker.
// A drift-gate test in this repo fails CI when this file and the committed
// deal-library-source.json snapshot disagree.

const DEFAULT_LIBRARY_BASE_URL = "https://library.favotrip.nl";

export const DEAL_LIBRARY_LINKS = {
  "235": {
    dealId: "235",
    title: "Maastricht Stedentrip met Pub Crawl",
    clips: ["1EDVbwvfgAdaHarQ3ZAQgFSe7zouSfNPD", "1_CvO09h5lLLYJTlabL9WxDrrhnh_oLAs", "1nG1FLfwBxQ1BP-_38DeTU7WImqlGc5rV", "1VZbnSS9LiG5D5CdxZySGHVjJMiTkEliB", "1NADdfu0KyQjpMbMk0Xj6uQFKDuoGk691", "1wL-1TjtWCxl6l2NZl1X4bqB6CxxckEHw", "14P8M0Nxy2C9z9bnfA-7wQN1s4L44zFbh", "1R942tHdCF_asVc2XGqJC0qrxihOCekfJ", "1U8RmXJg2rJMiIZ0kJnMooGgVYLxfKUb-", "1Oku41yAzUUxX6pGykGbkv5V0vvfedcGW", "1TloCgkqQMTCv_igjfOLOGQXu_fIAc9Gq", "1ZFsJYJMxYRL8AKL6raNNZCRw_CidY3um", "1RkiVP2_daROw0vNeuZoORg8-5VyZ9Sof", "1f9PnvsfUSgLl6qK2l6xA61Sqn3FvzJxR", "1DLMa7tXmDbqeqnWzU69YuxkfR0gpob25", "1cWmTuG2BEGtWRtjYVq7sdz1EnIc-HLH7", "1nbzBhEYVHSIK3Px41luU7Moeo31qUvyg", "1qgrmFoWxszEBxmi8Fh8YqKsxMLvjoBnN", "1o6TYYwe1NtQSR3DbDYzUiD55ivh-5Dgf", "1HrCqJbFAAtaDTkVb52GKj8CTjUG4iTVX", "19LMAhKMvsrzaSx2ICD0TqKV838Txxli6", "16RwMUkjyY3v1L6zMphn5QwNDkT46KgyN", "1phG5eDGjW7oeve3fHDO9AQrrzfXNJElm", "13v2yrHkV6rm8iU6zT_5gLcQOYmpN-ZXt", "1MwIFvHLmqSuW0z8EplkCi-UXTkospfkI", "1NhfZrgOp-IajLnZf_zVqFa-wshHjv3BM", "1dZi1fOwTohJNzX4UQbsMwOHPAf3coZj6", "1JYi1tqdOfEzaGWgyHKqhY8qhuKo7enJs", "1aCaGCgYC8YAY2f8vcVPzs-rl2UxqozLY", "1ylVQbikcRP_nftfUybfp5oNlxkD7Dnkn", "1NrdwGSqp3J_kL3_yIUj7WbR-t5Uhybt0", "1yl3ZxMC6-u83kOzVvSIv20fjT37AJgrw"],
  },
  "300": {
    dealId: "300",
    title: "Zeespa-weekend in Sopot aan de Oostzee",
    clips: ["1OnK9RLO2KTG4UBd9A8Y7mKPNBMNff6m3"],
  },
  "303": {
    dealId: "303",
    title: "Bergwellness in Karpacz aan de voet van de Sneeuwkop",
    clips: ["1NyYURBCIY--q3bRDHVBOyQ_EZI91s93Z"],
  },
  "304": {
    dealId: "304",
    title: "Wellnessweekend aan de Oostzee in Miedzyzdroje",
    clips: ["1zPXS1gr_t2paYk_sA26WJSBu8d4m9D0K"],
  },
  "307": {
    dealId: "307",
    title: "Stedentrip Gdansk: hanzestad aan de Motlawa",
    clips: ["1M704tGmez7zVM0Cfo9DBEM897Mww2kHJ"],
  },
  "308": {
    dealId: "308",
    title: "Stedentrip naar Wroclaw: het kleurrijke hart van Neder-Silezie",
    clips: ["1ADm1b1KCMTu23tzvBOk43TNPw-O0jXRh"],
  },
  "309": {
    dealId: "309",
    title: "Stedentrip Praag: weekend in de Gouden Stad",
    clips: ["1-P-pWfIp5BQlVFczoEWEffeTLP4uBR-2"],
  },
  "311": {
    dealId: "311",
    title: "Stedentrip Boedapest: Donau, thermaalbaden en de Burchtwijk",
    clips: ["1jt7wVnrEjVYOJUXiRynGbxu2j4sFB_KH"],
  },
  "312": {
    dealId: "312",
    title: "Familiemagie bij Disneyland Paris: hotel + parkticket",
    clips: ["1prnzB4nDwtqL0JVzpCyQWgWzbSQuMyJk"],
  },
  "313": {
    dealId: "313",
    title: "Stedentrip naar het middeleeuwse Toruń aan de Wisła",
    clips: ["1WfVymOanrvjRkRpJLCGJxa_RR2s5yFmc", "1_Ja1dQyeHAjWaQ5D4X03sC3JiW9gPF7L"],
  },
};

function normalizeDealId(dealId) {
  if (dealId == null) return null;
  const normalized = String(dealId).trim();
  return /^\d+$/.test(normalized) ? normalized : null;
}

function normalizeBaseUrl(baseUrl) {
  return String(baseUrl || DEFAULT_LIBRARY_BASE_URL).replace(/\/+$/, "");
}

export function getDealLibraryLink(dealId, baseUrl = DEFAULT_LIBRARY_BASE_URL) {
  const normalized = normalizeDealId(dealId);
  if (!normalized) return null;

  const mapping = DEAL_LIBRARY_LINKS[normalized];
  if (!mapping) return null;

  return {
    ...mapping,
    href: `${normalizeBaseUrl(baseUrl)}/?deal=${mapping.dealId}`,
  };
}

/**
 * Consumer-page video embed data (BLOK4 P0 #4): the deal's published
 * "Cinematic" clips as directly playable stream/poster URLs. Returns [] when
 * the deal has no published clips, so callers can render exactly nothing.
 */
export function getDealLibraryClips(dealId, baseUrl = DEFAULT_LIBRARY_BASE_URL) {
  const normalized = normalizeDealId(dealId);
  if (!normalized) return [];
  const mapping = DEAL_LIBRARY_LINKS[normalized];
  if (!mapping || !Array.isArray(mapping.clips)) return [];
  const base = normalizeBaseUrl(baseUrl);
  return mapping.clips.map((fileId) => ({
    fileId,
    streamUrl: `${base}/api/stream?fileId=${encodeURIComponent(fileId)}`,
    posterUrl: `${base}/thumbnails/${encodeURIComponent(fileId)}.jpg`,
  }));
}

/** Ingest endpoint for the buyer-side play event (deal_id + file_id). */
export function getLibraryTrackViewUrl(baseUrl = DEFAULT_LIBRARY_BASE_URL) {
  return `${normalizeBaseUrl(baseUrl)}/api/track-view`;
}
